import ApplicationController from  '../application_controller'

export default class extends ApplicationController {
    static targets = [
      'tabsView',
      'tabsWrapper',
      'tabsContainer',
      'tabHeader',
      'pinTabsContainer',
      'pinTabsHeader',
      'pinTabsWrapper']
    static values = ['allTabs','allButtons','tabView']
  connect(){
    super.connect()
    this.tabViewValue = new TabsView(this.tabsViewTarget)

    // Check URL parameters for tab to open
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get('tab');
    if (tabParam) {
      this.tabViewValue.openTabFromParam(tabParam);
    }
  }

  
}

class TabsView {
  constructor(element) {
    this.element = element
    this.btns =  this.htmlClectionToArray(element.querySelector('.tabsWrapper > header').children)
    this.tabs = this.htmlClectionToArray(element.querySelector('.tabsWrapper > .tabs').children)
    this.currentBtn = this.btns[0]
    this.currentTab = this.tabs[0]
    this.chooseTab(this.currentBtn)
    this.setEventListener()
  }

  hideAll(){
    this.tabs.forEach(tab => {
      tab.classList.add("hide")
    });
    this.btns.forEach(button => {
      button.classList.remove("current")
    });
  }
  chooseTab(btn){
    this.hideAll()
    this.setCurrentBtn(btn)
    this.currentBtn = btn
    this.currentTab = this.element.querySelector(`#${btn.dataset.tab}`)
    this.showTab(this.currentTab)
  }
  showTab(tab){
    tab.classList.remove("hide")
  }
  
  openTabFromParam(tabId) {
    const targetBtn = this.btns.find(btn => btn.dataset.tab === tabId);
    if (targetBtn) {
      this.chooseTab(targetBtn);
      // Scroll to the tab if needed
      targetBtn.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      
      // Mark coordinator form as viewed if opening "טופס רכז" tab (id-8) directly from URL
      if (tabId === 'id-8') {
        // Add a small delay to ensure page is fully loaded
        setTimeout(() => {
          this.markCoordinatorFormAsViewed();
        }, 500);
      }
    }
  }
  
  setCurrentBtn(btn) {
    btn.classList.add("current")
  }
  moveTab(tab,btn, from, to) {
    from.removeChild(tab)
    to.appendChild(tab) 
    from.closest('.wrapper').querySelector(':scope > .header').removeChild(btn)
    to.closest('.wrapper').querySelector(':scope > .header').appendChild(btn)

  }
  show_tab_custom_buttons(current_tab) {
    const btns_to_hide = this.element.querySelectorAll('.custom_buttons');
    const current_tab_btns = this.element.querySelectorAll(`.${current_tab}_only`);
    for(var i = 0; i < btns_to_hide.length; i++){
        btns_to_hide[i].style.visibility = "hidden";
        btns_to_hide[i].style.display = "none"; 
    }
    for(var i = 0; i < current_tab_btns.length; i++){
        current_tab_btns[i].style.visibility = "unset";
        current_tab_btns[i].style.display = "block"; 
    }

  }
  setEventListener(){
    const that = this
      //this.setCurrentTabs()
      this.btns.forEach(btn => {
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          const current_tab = event.target.closest('.tabBtn').getAttribute('data-tab');
          this.show_tab_custom_buttons(current_tab);
          this.chooseTab(event.target.closest('.tabBtn'))
          
          // Mark coordinator form as viewed if clicking on "טופס רכז" tab (id-8)
          if (current_tab === 'id-8' && window.location.pathname.includes('/events/')) {
            this.markCoordinatorFormAsViewed();
          }
        }) 
        btn.addEventListener('dblclick', (event) => {
          event.preventDefault();
          this.pinTab(event.target.closest('.tabBtn'))
        })
      })

      var element = this.element.querySelector(':scope > .pinTabsWrapper')
      //create box in bottom-left
      var resizer = document.createElement('div');
      resizer.className="border"
      //Append Child to Element
      element.appendChild(resizer);
      //box function onmousemove
      resizer.addEventListener('mousedown', initResize, false);

      //this.element funtion mousemove & mouseup
      function initResize(e) {
        e.preventDefault()
        that.element.addEventListener('mousemove', Resize, false);
        that.element.addEventListener('mouseup', stopResize, false);
      }
      //resize the element
      function Resize(e) {
        element.style.width = e.clientX - element.offsetLeft + 'px';
      }
      //on mouseup remove this.element functions mousemove & mouseup
      function stopResize(e) {
        that.element.removeEventListener('mousemove', Resize, false);
        that.element.removeEventListener('mouseup', stopResize, false);
      }
  }
  pinTab(btn) {
    this.currentBtn = btn
    this.currentTab = this.element.querySelector(`#${btn.dataset.tab}`)
    const pinC = this.element.querySelector(':scope > .pinTabsWrapper > .pinTabs')
    const tabC = this.element.querySelector(':scope > .tabsWrapper > .tabs')
    const tabH = this.element.querySelector(':scope > .tabsWrapper > .tabHeader')
    if (this.currentBtn.parentElement == tabH) {
      this.moveTab(this.currentTab,this.currentBtn,tabC,pinC)
      this.tabs = this.htmlClectionToArray(this.element.querySelector('.tabsWrapper > .tabs').children)
      this.btns =  this.htmlClectionToArray(this.element.querySelector('.tabsWrapper > header').children)
      this.chooseTab(this.btns[0])
   
    } else {
      this.moveTab(this.currentTab,this.currentBtn,pinC,tabC)
      this.tabs = this.htmlClectionToArray(this.element.querySelector('.tabsWrapper > .tabs').children)
      this.btns =  this.htmlClectionToArray(this.element.querySelector('.tabsWrapper > header').children)
      this.chooseTab(this.currentBtn)
      if (pinC.children.length == 0) this.element.querySelector(':scope > .pinTabsWrapper').style.width = "unset"
   }
   }

  htmlClectionToArray(collection) {
   return Array.prototype.slice.call(collection)
  }
  
  markCoordinatorFormAsViewed() {
    // Show a subtle status indicator to the user
    this.showStatusMessage('סימון הטופס כנצפה...', 'info');
    
    // Get event ID from URL or data attribute
    const eventId = this.getEventId();
    
    if (!eventId) {
      this.showStatusMessage('שגיאה: לא נמצא מזהה אירוע', 'error');
      return;
    }
    
    const url = `/events/${eventId}/mark_coordinator_form_viewed`;
    
    // Make silent AJAX request to mark form as viewed
    fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
      },
      body: JSON.stringify({})
    })
    .then(response => {
      return response.json();
    })
    .then(data => {
      if (data.success) {
        this.showStatusMessage('הטופס סומן כנצפה בהצלחה', 'success');
        // Update the notification count in the UI
        if (typeof data.new_count !== 'undefined') {
          this.updateNotificationUI(data.new_count);
        } else {
          // Fallback: manually decrease the current count by 1
          this.decreaseNotificationCount();
        }
      } else {
        this.showStatusMessage('הטופס כבר נצפה', 'warning');
      }
    })
    .catch(error => {
      this.showStatusMessage('שגיאה בסימון הטופס', 'error');
    });
  }
  
  getEventId() {
    // Try to get event ID from URL path
    const pathParts = window.location.pathname.split('/');
    const eventsIndex = pathParts.indexOf('events');
    if (eventsIndex !== -1 && pathParts[eventsIndex + 1]) {
      return pathParts[eventsIndex + 1];
    }
    
    // Fallback: try to get from data attribute or other sources
    const eventElement = document.querySelector('[data-event-id]');
    if (eventElement) {
      return eventElement.getAttribute('data-event-id');
    }
    
    return null;
  }
  
  updateNotificationUI(newCount) {
    // Update the badge count
    const badge = document.querySelector('.coord-forms-badge');
    const notificationWrapper = document.querySelector('.dropdown-notification');
    
    if (badge) {
      if (newCount > 0) {
        badge.textContent = newCount > 99 ? '99+' : newCount;
        
        // Update the dropdown title
        const dropdownTitle = document.querySelector('.coordinator-forms-dropdown li:first-child');
        if (dropdownTitle) {
          dropdownTitle.innerHTML = dropdownTitle.innerHTML.replace(/\(\d+\)/, `(${newCount})`);
        }
      } else {
        // Hide the entire notification section if count is 0
        if (notificationWrapper) {
          notificationWrapper.style.display = 'none';
        }
      }
    }
    
    // If we still see notifications after marking as viewed, schedule a page refresh
    if (newCount === 0 && badge && badge.textContent !== '0') {
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  }
  
  showStatusMessage(message, type = 'info') {
    // Create or update status message element
    let statusEl = document.getElementById('coordinator-form-status');
    if (!statusEl) {
      statusEl = document.createElement('div');
      statusEl.id = 'coordinator-form-status';
      statusEl.style.cssText = `
        position: fixed;
        top: 80px;
        right: 20px;
        z-index: 10000;
        padding: 12px 20px;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 500;
        max-width: 300px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        transition: all 0.3s ease;
      `;
      document.body.appendChild(statusEl);
    }
    
    // Set message and styling based on type
    statusEl.textContent = message;
    
    const colors = {
      info: { bg: '#e3f2fd', color: '#1976d2', border: '#bbdefb' },
      success: { bg: '#e8f5e8', color: '#2e7d32', border: '#c8e6c9' },
      warning: { bg: '#fff3e0', color: '#f57c00', border: '#ffcc02' },
      error: { bg: '#ffebee', color: '#d32f2f', border: '#ffcdd2' }
    };
    
    const style = colors[type] || colors.info;
    statusEl.style.backgroundColor = style.bg;
    statusEl.style.color = style.color;
    statusEl.style.border = `1px solid ${style.border}`;
    
    // Show the message
    statusEl.style.opacity = '1';
    statusEl.style.transform = 'translateY(0)';
    
    // Auto-hide after 3 seconds for success/info, 5 seconds for warning/error
    const hideDelay = (type === 'success' || type === 'info') ? 3000 : 5000;
    setTimeout(() => {
      if (statusEl) {
        statusEl.style.opacity = '0';
        statusEl.style.transform = 'translateY(-10px)';
        setTimeout(() => {
          if (statusEl && statusEl.parentNode) {
            statusEl.parentNode.removeChild(statusEl);
          }
        }, 300);
      }
    }, hideDelay);
  }
  
  decreaseNotificationCount() {
    // Get current count from badge
    const badge = document.querySelector('.coord-forms-badge');
    if (badge) {
      const currentText = badge.textContent;
      let currentCount = 0;
      
      if (currentText === '99+') {
        currentCount = 99; // Can't know exact number, assume 99
      } else {
        currentCount = parseInt(currentText) || 0;
      }
      
      const newCount = Math.max(0, currentCount - 1);
      
      this.updateNotificationUI(newCount);
    }
  }
}



